import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';

import logo from './assets/Images/space-designs-logo.png';

// Dynamically set favicon
const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
link.type = 'image/png';
link.rel = 'icon';
link.href = logo;
document.getElementsByTagName('head')[0].appendChild(link);

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);




